import React from "react";

const KycCard = (props) => {
  var BASE_URL = `${endpoints[environment].api_base}/api/v1/files/download/`;
  const { data } = props;
  return (
    <div className="card redesigned_profile_card h-100">
      <div className="card-header border-0">
        <div className="d-flex align-items-center">
          <img
            src={imagepaths.userSearchIcon}
            alt="userSearchIcon"
            className="card_icon"
            width="22"
            height="22"
          />
          <h5 className="title ms-2 mb-0">KYC Details</h5>
        </div>
      </div>
      <div className="card-body">
        <div className="row g-0">
          <div className="col-12 col-lg-6 pe-lg-4" style={{ borderRight: "1px solid #F0F0F0" }}>
            <ul className="stacked_list h-100">
              <li>
                <span className="label">Aadhar No</span>
                <span className="value">
                  {(data?.aadharCardInfo &&
                    `XXXX-XXXX-${data?.aadharCardInfo?.uid}`) ||
                    "-"}
                </span>
              </li>
              <li>
                <span className="label">PIN Code</span>
                <span className="value">
                  {(data?.aadharCardInfo &&
                    data?.aadharCardInfo?.pincode) ||
                    "-"}
                </span>
              </li>
              <li>
                <span className="label">City</span>
                <span className="value">
                  {(data?.aadharCardInfo &&
                    data?.aadharCardInfo?.city) ||
                    "-"}
                </span>
              </li>
            </ul>
          </div>

          <div className="col-12 col-lg-6 ps-lg-4 mt-4 mt-lg-0">
            <ul className="stacked_list h-100">
              <li>
                <span className="label">PAN No.</span>
                <span className="value">
                  {(data?.panCardInfo &&
                    data?.panCardInfo?.number) ||
                    "-"}
                </span>
              </li>
              <li>
                <span className="label">Aadhar Address</span>
                <span className="value">
                  {(data?.aadharCardInfo &&
                    data?.aadharCardInfo?.address) ||
                    "-"}
                </span>
              </li>
              <li>
                <span className="label">State</span>
                <span className="value">
                  {(data?.aadharCardInfo &&
                    data?.aadharCardInfo?.state) ||
                    "-"}
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default constore(KycCard);

